// extracted by mini-css-extract-plugin
module.exports =  {"base-badge":"ZA9_vlB","baseBadge":"ZA9_vlB","content":"lsEA2Z8"};